import React from "react";
import { PropTypes } from "prop-types";

export default function InfoTooltip({
  children,
  width,
  position,
  type,
  showIcon,
}) {
  return (
    <div
      className={`editor-info-tooltip editor-tooltip ${
        position ? `editor-tooltip-${position}` : "editor-tooltip-center"
      } ${type ? `editor-tooltip-${type}` : ""}`}
    >
      {showIcon && <i className="material-icons-outlined">info</i>}
      <span className="editor-tooltiptext" style={width ? { width } : {}}>
        {children}
      </span>
    </div>
  );
}

InfoTooltip.propTypes = {
  children: PropTypes.node,
  position: PropTypes.string,
  showIcon: PropTypes.bool,
  type: PropTypes.string,
  width: PropTypes.string,
};

InfoTooltip.defaultProps = {
  showIcon: true,
};
